import { Link } from 'gatsby';
import Img from 'gatsby-image';
import propTypes from 'prop-types';
import React, { useState, useEffect } from 'react';

import BagIcon, { BagIconFilled } from '../../assets/svg/BagIcon';
import { useBag } from '../../context/BagContext';
import { useBagController } from '../../context/BagDisplayContext';
import { currencyMask } from '../../services/maskService';

const ProductCard = ({ product }) => {
  const { id, name, price, image, slug } = product;
  const { addProduct, removeProduct, checkProduct, bag } = useBag();
  const { showBag } = useBagController();
  const [isAdded, setAdded] = useState(checkProduct(id));

  console.log(product)

  const toggleBag = () => {
    if (isAdded) {
      removeProduct(id);
      setAdded(false);
    } else {
      addProduct({ ...product, quantity: 1 });
      setAdded(true);
      showBag();
    }
  };

  useEffect(() => {
    setAdded(checkProduct(id));
  }, [bag, id, checkProduct]);

  return (
    <React.Fragment>
      <Link to={`/products${slug}`} className="cursor-pointer">
        <div className="max-w-sm w-full lg:max-w-full lg:flex" style={{boxShadow: '0px 5px 20px rgb(0 0 0 / 20%)'}}>
          <div className="h-48 lg:h-auto lg:w-48 flex-none bg-cover rounded-t lg:rounded-t-none lg:rounded-l text-center overflow-hidden" title="BaliBrothers">
            
              {image.childImageSharp ? (
                <Img style={{height: '100%'}} fluid={image.childImageSharp.fluid} alt={name} />
              ) : (
                <div className="relative pb-4/3">
                  <img style={{height: '100%'}} className="absolute w-full h-full object-cover" src={image} alt={name} />
                </div>
              )}
          </div>
          <div className="border-r border-b border-l border-gray-400 lg:border-l-0 lg:border-t lg:border-gray-400 bg-white rounded-b lg:rounded-b-none lg:rounded-r p-4 flex flex-col justify-between leading-normal">
            <div className="mb-8">
              <p className="text-sm text-gray-600 flex items-center" style={{alignItems: 'end'}}>
                {product.new && <img src="/img/fire.gif" alt="Only Once" style={{height: '25px'}} /> }
                {product.new ? 'Most Wanted' : '' } 
              </p>
              <div className="text-gray-900 font-bold text-xl mb-2">{name}</div>
              <p className="text-gray-700 text-base">{product.description}</p>
            </div>
            <div className="flex items-center">
              <div className="text-sm">
              <p className="text-gray-600">{product.date}</p>
                <p className="text-gray-900 leading-none" style={{display: 'flex', alignItems: 'center'}}>Powered by BaliBrothers <img style={{height: '25px'}} src="/img/logo.png" alt="" /></p>
              </div>
            </div>
          </div>
        </div>
      </Link>
    </React.Fragment>
  );
};

ProductCard.propTypes = {
  product: propTypes.shape({
    id: propTypes.string.isRequired,
    name: propTypes.string.isRequired,
    price: propTypes.number.isRequired,
    image: propTypes.oneOfType([propTypes.shape(), propTypes.string]).isRequired,
    seller: propTypes.shape.isRequired,
    slug: propTypes.string.isRequired,
    new: propTypes.bool.isRequired,
  }).isRequired,
};

export default ProductCard;
